class SurveyContainer {
  constructor(params) {
    this.element = params.element;
    this.toggles = Array.from(
      this.element.querySelectorAll('[data-survey-toggle]')
    );
    this.content = Array.from(
      this.element.querySelectorAll('[data-survey-content]')
    );
    this.originalTabindex = this.element.getAttribute('tabindex');
  }

  init() {
    if (this.toggles.length > 0 && this.content?.length > 0) {
      this.eventBinding();
      this.setupFocusability();
    }
  }

  destroy() {
    this.eventUnbinding();
    this.removeFocusability();
  }

  eventBinding() {
    this.toggles.forEach(toggle => {
      toggle.addEventListener('click', this.clickHandler.bind(this));
    });
  }

  eventUnbinding() {
    this.toggles.forEach(toggle => {
      toggle.removeEventListener('click', this.clickHandler);
    });
  }

  clickHandler(e) {
    e.preventDefault();
    let currentIndex = 0;
    const direction = e.target.dataset.surveyToggle === 'previous' ? -1 : 1;

    this.content.forEach((content, index) => {
      if (content.dataset.surveyContent === 'visible') {
        currentIndex = index;
      }
      content.setAttribute('data-survey-content', 'hidden');
    });

    this.content[
      currentIndex + direction < 0 ||
      currentIndex + direction >= this.content.length
        ? 0
        : currentIndex + direction
    ].setAttribute('data-survey-content', 'visible');

    // Focus container
    this.element.focus();
  }

  setupFocusability() {
    this.element.setAttribute('tabindex', 0);
  }

  removeFocusability() {
    if (this.originalTabindex)
      this.element.setAttribute('tabindex', this.originalTabindex);
  }
}

const surveyContainer = document.querySelectorAll('.survey-container');
const surveyContainerInstances = [];

surveyContainer.forEach(element => {
  const containerInstance = new SurveyContainer({ element });
  containerInstance.init();
  surveyContainerInstances.push(containerInstance);
});
